import React, { Component } from 'react';
import { FileText, Bookmark, LayoutGrid, Smartphone, Printer, Megaphone, Camera, Package } from 'lucide-react';
export type PageId = 'readme' | 'dossier' | 'feed' | 'stories' | 'print' | 'ads' | 'master';
interface PageSidebarProps {
  active: PageId;
  onSelect: (id: PageId) => void;
}
const pages: {
  id: PageId;
  code: string;
  label: string;
  icon: React.ReactNode;
}[] = [{
  id: 'readme',
  code: '00',
  label: 'README',
  icon: <FileText className="w-3.5 h-3.5" data-id="element-1660" />
}, {
  id: 'dossier',
  code: '01',
  label: 'BRAND_DOSSIER',
  icon: <Bookmark className="w-3.5 h-3.5" data-id="element-1661" />
}, {
  id: 'feed',
  code: '02',
  label: 'TEMPLATES_FEED',
  icon: <LayoutGrid className="w-3.5 h-3.5" data-id="element-1662" />
}, {
  id: 'stories',
  code: '03',
  label: 'TEMPLATES_STORIES',
  icon: <Smartphone className="w-3.5 h-3.5" data-id="element-1663" />
}, {
  id: 'print',
  code: '04',
  label: 'TEMPLATES_PRINT_OFFLINE',
  icon: <Printer className="w-3.5 h-3.5" data-id="element-1664" />
}, {
  id: 'ads',
  code: '05',
  label: 'AD_VARIANTS',
  icon: <Megaphone className="w-3.5 h-3.5" data-id="element-1665" />
}, {
  id: 'master',
  code: '06',
  label: 'MASTER_EXPORT',
  icon: <Package className="w-3.5 h-3.5" data-id="element-1666" />
}];
export function PageSidebar({
  active,
  onSelect
}: PageSidebarProps) {
  return <aside className="w-60 bg-film-black text-white flex flex-col h-screen sticky top-0 shrink-0 border-r border-white/10" data-id="element-1667">
      {/* File header */}
      <div className="p-4 border-b border-white/10" data-id="element-1668">
        <div className="flex items-center gap-2 mb-2" data-id="element-1669">
          <img src="https://cdn.magicpatterns.com/uploads/6S42RJUThA4LVcV5MgRYxz/filmnotes-fn-full-icon_1024.png" alt="fn" className="w-6 h-6" data-id="element-1670" />
          <span className="font-display font-bold text-sm" data-id="element-1671">Film Notes</span>
        </div>
        <p className="font-mono text-[10px] text-white/50 leading-tight" data-id="element-1672">
          template-library.fig
          <br data-id="element-1673" />
          v1.0 · May 2026
        </p>
      </div>

      {/* Pages */}
      <div className="flex-1 overflow-y-auto py-3" data-id="element-1674">
        <div className="px-4 mb-2" data-id="element-1675">
          <p className="font-mono text-[10px] uppercase tracking-wider text-white/40" data-id="element-1676">
            Pages
          </p>
        </div>
        <nav data-id="element-1677">
          {pages.map(p => {
          const isActive = active === p.id;
          return <button key={p.id} onClick={() => onSelect(p.id)} className={`w-full text-left px-4 py-2 flex items-center gap-2 transition-colors group relative ${isActive ? 'bg-white/5' : 'hover:bg-white/5'}`} data-id="element-1678">
                {isActive && <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-film-red" data-id="element-1679"></div>}
                <span className={`font-mono text-[10px] ${isActive ? 'text-film-red' : 'text-white/40'}`} data-id="element-1680">
                  {p.code}
                </span>
                <span className={`text-white/60 ${isActive ? 'text-white' : ''}`} data-id="element-1681">
                  {p.icon}
                </span>
                <span className={`font-mono text-[11px] ${isActive ? 'text-white' : 'text-white/70'}`} data-id="element-1682">
                  {p.label}
                </span>
              </button>;
        })}
        </nav>

        {/* Components section */}
        <div className="px-4 mt-6 mb-2" data-id="element-1683">
          <p className="font-mono text-[10px] uppercase tracking-wider text-white/40" data-id="element-1684">
            Components
          </p>
        </div>
        <div className="px-4 space-y-1.5" data-id="element-1685">
          {['CAT_LAB', 'CAT_TIP', 'CAT_FEATURE', 'CAT_COMMUNITY', 'CAT_GEAR'].map(c => <div key={c} className="font-mono text-[10px] text-white/50 flex items-center gap-2" data-id="element-1686">
              <div className="w-1.5 h-1.5 bg-film-red" data-id="element-1687"></div>
              {c}
            </div>)}
          <div className="h-2" data-id="element-1688"></div>
          {['FMT_REEL_COVER', 'FMT_CAROUSEL', 'FMT_SINGLE', 'FMT_STORY', 'FMT_AD'].map(f => <div key={f} className="font-mono text-[10px] text-white/50 flex items-center gap-2" data-id="element-1689">
              <div className="w-1.5 h-1.5 bg-film-orange" data-id="element-1690"></div>
              {f}
            </div>)}
        </div>
      </div>
    </aside>;
}